import * as Yup from 'yup';
import * as validationSchema from './validationSchema';

export const releaseLockValidationScheme = Yup.object({
  IdentificationNumber: validationSchema.idNumSchema,
  CaseId: Yup.string().required('שדה חובה'),
});
